CriteriaVisibilityController.$inject = ['$scope', '$translate', '$mdDialog', 'selectorsGroups'];
export function CriteriaVisibilityController($scope, $translate, $mdDialog, selectorsGroups) {

  $scope.onChange = onChange;
  $scope.close = close;

  init();

  function close() {
    $mdDialog.hide();
    $scope.selectorsGroups.saveVisibilitiesToLocalStorage();
    if ($scope.atLeastOneSelectorWasRemoved) {
      $scope.selectors.forEach(selector => {
        // We clear the criteria before hiding them
        if (!selector.isDisplayed) {
          selector.remove();
        }
      });
      $scope.selectorsGroups.submitQuery();
    }
  }

  function onChange(selector) {
    if (!selector.isDisplayed) {
      $scope.atLeastOneSelectorWasRemoved = true;
    }
  }

  function init() {
    $scope.selectorsGroups = selectorsGroups;
    $scope.selectors = selectorsGroups.selectors();
  }

}
